// import styles from './../../src/abstracts/_typography.scss';

const styles = {
  tpSizeX2S: 12,
  tpSizeXs: 13,
  tpSizeS: 14,
  tpSizeM: 15,
  tpSizeL: 16,
  tpSizeXl: 17,
  tpSizeX2L: 18,
  tpSizes: { x2s: 12, xs: 13, s: 14, m: 15, l: 16, xl: 17, x2l: 18 },
  tpAlign: [ 'left', 'center', 'right' ],
  tpValign: 'middle',
  tpFontS: 'MuseoSans_300',
  tpFontM: 'MuseoSans_500',
  tpFontL: 'MuseoSans_700',
  tpFonts: { s: 'MuseoSans_300', m: 'MuseoSans_500', l: 'MuseoSans_700' }
}

export default styles;